import React, { lazy, Suspense } from "react";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "./App.css";
import "react-toastify/dist/ReactToastify.min.css";

const Admin = lazy(() => import("./admin/Admin"));
const Content = lazy(() => import("./content/Content"));

const App = () => {
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route exact path="/" component={Content} />
        <Route exact={false} path="/admin" component={Admin} />
        <Route exact={false} path="/" render={() => <Redirect to={"/"} />} />
      </Switch>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnVisibilityChange
        draggable={false}
        pauseOnHover={false}
      />
    </Suspense>
  );
};

export default withRouter(App);
